import { types } from 'mobx-state-tree';
import { wishlistCardActions } from './Actions';
const Company = {
    company_lid: types.maybeNull(types.number),
    name: types.optional(types.string, ''),
    domain: types.optional(types.string, ''),
};
const views = () => ({});
const OriginalState = {
    company: types.maybeNull(types.model(Company)),
    firstName: types.optional(types.string, ''),
    lastName: types.optional(types.string, ''),
    title: types.optional(types.string, ''),
};
const ModelProps = {
    contactFirstName: types.optional(types.string, ''),
    contactLastName: types.optional(types.string, ''),
    contactEmail: types.optional(types.string, ''),
    contactPhone: types.optional(types.string, ''),
    contactCompany: types.maybeNull(types.model(Company)),
    contactTitle: types.optional(types.string, ''),
    isPartialProfile: types.optional(types.boolean, false),
    originalState: types.maybeNull(types.model(OriginalState)),
    shouldInitState: types.optional(types.boolean, false),
    isSavingToWishlist: types.optional(types.boolean, false),
};
const WishlistCard = types.model(ModelProps).actions(wishlistCardActions).views(views);
export default WishlistCard;
